import React, { useState, useEffect } from 'react';
        import { motion } from 'framer-motion';
        import { supabase } from '../../config/supabase';
        import SafeIcon from '../../common/SafeIcon';
        import * as FiIcons from 'react-icons/fi';

        const { FiCheck, FiX } = FiIcons;

        const PendingEventsTab = () => {
          const [pendingEvents, setPendingEvents] = useState([]);
          const [loading, setLoading] = useState(true);

          useEffect(() => {
            fetchPendingEvents();
          }, []);

          const fetchPendingEvents = async () => {
            try {
              const { data, error } = await supabase
                .from('events')
                .select('*, profiles(name, instagram_handle)')
                .eq('status', 'pending')
                .order('created_at', { ascending: false });

              if (error) throw error;
              setPendingEvents(data || []);
            } catch (error) {
              console.error('Error fetching pending events:', error);
            } finally {
              setLoading(false);
            }
          };

          const handleApprove = async (id) => {
            try {
              const { error } = await supabase.from('events').update({ status: 'approved' }).eq('id', id);
              if (error) throw error;
              fetchPendingEvents();
            } catch (error) {
              console.error('Error approving event:', error);
            }
          };

          const handleReject = async (id) => {
            if (window.confirm('Are you sure you want to reject this event?')) {
              try {
                const { error } = await supabase.from('events').delete().eq('id', id);
                if (error) throw error;
                fetchPendingEvents();
              } catch (error) {
                console.error('Error rejecting event:', error);
              }
            }
          };

          if (loading) {
            return (
              <div className="flex items-center justify-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
              </div>
            );
          }

          return (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900">Pending Events ({pendingEvents.length})</h2>
              </div>
              {pendingEvents.length === 0 ? (
                <div className="text-center py-12">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">No pending events</h3>
                  <p className="text-gray-600">All events have been reviewed.</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {pendingEvents.map((event) => (
                    <motion.div
                      key={event.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow"
                    >
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">{event.title}</h3>
                        <p className="text-gray-600 text-sm mb-4">by {event.profiles?.name || 'N/A'}</p>
                        <p className="text-gray-700 text-sm mb-4 line-clamp-3">{event.description}</p>
                      
                      <div className="flex space-x-2">
                        <button onClick={() => handleApprove(event.id)} className="flex-1 flex items-center justify-center space-x-2 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors">
                          <SafeIcon icon={FiCheck} />
                          <span>Approve</span>
                        </button>
                        <button onClick={() => handleReject(event.id)} className="flex-1 flex items-center justify-center space-x-2 bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 transition-colors">
                          <SafeIcon icon={FiX} />
                          <span>Reject</span>
                        </button>
                      </div>
                    </motion.div>
                  ))}
                </div>
              )}
            </div>
          );
        };

        export default PendingEventsTab;